var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { DownloadIcon, FileIcon, LoaderIcon, XIcon } from 'lucide-vue-next';
import { fetchExports, downloadExport, dismissExport } from '@/core/export/exports-api';
import { exportEvents } from '@/core/export/export-events';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ExportsDropdown',
    setup(__props, { expose: __expose }) {
        const isOpen = ref(false);
        const exports = ref([]);
        const isLoading = ref(false);
        let pollInterval = null;
        const totalCount = computed(() => exports.value.length);
        const completedCount = computed(() => exports.value.filter(e => e.is_completed).length);
        const inProgressCount = computed(() => exports.value.filter(e => e.is_in_progress).length);
        const hasExports = computed(() => exports.value.length > 0);
        const toggleDropdown = () => {
            isOpen.value = !isOpen.value;
            if (isOpen.value) {
                loadExports();
            }
        };
        const closeDropdown = () => {
            isOpen.value = false;
        };
        const loadExports = () => __awaiter(this, void 0, void 0, function* () {
            try {
                isLoading.value = true;
                const response = yield fetchExports();
                exports.value = response.exports;
            }
            catch (error) {
                console.error('Error loading exports:', error);
            }
            finally {
                isLoading.value = false;
            }
        });
        const handleDownload = (exportItem) => __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield downloadExport(exportItem.id);
                if (response.download_url) {
                    window.open(response.download_url, '_blank');
                    // Remove from list after download
                    exports.value = exports.value.filter(e => e.id !== exportItem.id);
                    if (exports.value.length === 0) {
                        closeDropdown();
                    }
                }
            }
            catch (error) {
                console.error('Error downloading export:', error);
            }
        });
        const handleDismiss = (exportItem) => __awaiter(this, void 0, void 0, function* () {
            try {
                yield dismissExport(exportItem.id);
                exports.value = exports.value.filter(e => e.id !== exportItem.id);
                if (exports.value.length === 0) {
                    closeDropdown();
                }
            }
            catch (error) {
                console.error('Error dismissing export:', error);
            }
        });
        const truncateFilename = (filename, maxLength = 25) => {
            if (filename.length <= maxLength)
                return filename;
            const ext = filename.split('.').pop() || '';
            const name = filename.slice(0, filename.length - ext.length - 1);
            const truncatedName = name.slice(0, maxLength - ext.length - 4) + '...';
            return `${truncatedName}.${ext}`;
        };
        const getStatusText = (exportItem) => {
            if (exportItem.is_in_progress) {
                return exportItem.status === 'pending' ? 'En cola...' : 'Generando...';
            }
            if (exportItem.is_completed) {
                return 'Listo para descargar';
            }
            return exportItem.status;
        };
        const startPolling = () => {
            pollInterval = setInterval(() => __awaiter(this, void 0, void 0, function* () {
                if (inProgressCount.value > 0 || exports.value.length === 0) {
                    yield loadExports();
                }
            }), 3000);
        };
        const stopPolling = () => {
            if (pollInterval) {
                clearInterval(pollInterval);
                pollInterval = null;
            }
        };
        const openAndRefresh = () => __awaiter(this, void 0, void 0, function* () {
            yield loadExports();
            isOpen.value = true;
        });
        let unsubscribe = null;
        onMounted(() => {
            loadExports();
            startPolling();
            // Subscribe to export started events
            unsubscribe = exportEvents.onExportStarted(() => {
                openAndRefresh();
            });
        });
        onUnmounted(() => {
            stopPolling();
            if (unsubscribe) {
                unsubscribe();
            }
        });
        // Expose methods to control dropdown from outside (called when new export is triggered)
        __expose({ loadExports, openAndRefresh, isOpen });
        const __returned__ = { isOpen, exports, isLoading, get pollInterval() { return pollInterval; }, set pollInterval(v) { pollInterval = v; }, totalCount, completedCount, inProgressCount, hasExports, toggleDropdown, closeDropdown, loadExports, handleDownload, handleDismiss, truncateFilename, getStatusText, startPolling, stopPolling, openAndRefresh, get unsubscribe() { return unsubscribe; }, set unsubscribe(v) { unsubscribe = v; }, get DownloadIcon() { return DownloadIcon; }, get FileIcon() { return FileIcon; }, get LoaderIcon() { return LoaderIcon; }, get XIcon() { return XIcon; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
